module.exports = flarum.core.compat['tags/common/components/TagSelectionModal'];